import AVdxbModalHeader from './index.vue';

AVdxbModalHeader.install = app => {
  app.component(AVdxbModalHeader.name, AVdxbModalHeader);
};

export default AVdxbModalHeader;
